// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"0f51c473","787":"d9ccdd7d"}[chunkId] + ".chunk.js";
};